var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04492 0H11.4199C12.5478 0 13.4648 0.91407 13.4648 2.04492V11.4199C13.4648 12.5479 12.5508 13.4649 11.4199 13.4649H2.04492C0.91699 13.4649 0 12.5508 0 11.4199V2.04492C0 0.91699 0.91406 0 2.04492 0Z",
    fill: "url(#paint0_linear_7797_1852)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 5.86531V11.628C13.4619 12.6417 12.6416 13.462 11.6279 13.462H1.83398C0.82031 13.462 0 12.6417 0 11.628V7.18074C1.18945 8.12703 4.18652 9.93469 6.73242 6.72957C8.57811 4.40926 11.3496 4.80477 13.4619 5.86531Z",
    fill: "url(#paint1_linear_7797_1852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97071 4.83985C3.77001 4.83985 4.41797 4.19188 4.41797 3.39258C4.41797 2.59328 3.77001 1.94531 2.97071 1.94531C2.17141 1.94531 1.52344 2.59328 1.52344 3.39258C1.52344 4.19188 2.17141 4.83985 2.97071 4.83985Z",
    fill: "url(#paint2_linear_7797_1852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7797_1852",
    x1: 0.59868,
    y1: 0.59971,
    x2: 12.8632,
    y2: 12.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7797_1852",
    x1: 2.39264,
    y1: 4.78909,
    x2: 11.7268,
    y2: 14.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83E2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7797_1852",
    x1: 1.94839,
    y1: 2.37027,
    x2: 3.99361,
    y2: 4.41519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83E2FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.8418c193ef78d8e2e8f8df4d7357b47f.svg";
export { ForwardRef as ReactComponent };